/* GlobalStyle.jsx */
import { createGlobalStyle } from "styled-components";
import { reset } from "styled-reset";
import "./font.css";
import styled from "styled-components";

const GlobalStyle = createGlobalStyle`
${reset} // normalize

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
  min-height: 100vh;
  overflow: hidden;
  touch-action: none;
  
  @supports (-webkit-touch-callout: none) {
    min-height: -webkit-fill-available;
  }
}
a {
    color: var(--black);
    text-decoration: none;
    &:visited, &:link, &:active, &:hover{
      color: var(--black);
      text-decoration: none;
    }
}
:root {
    --white: #fff;
    --black: #000;
    --main: #16a085;
    --sub: #DDFED8;
}

`;

export default GlobalStyle;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
